// NOTE This file is auto-generated by Contentlayer

export { isType } from 'contentlayer2/client'

// NOTE During development Contentlayer imports from `.mjs` files to improve HMR speeds.
// During (production) builds Contentlayer it imports from `.json` files to improve build performance.
import allChangelogs from './Changelog/_index.json' assert { type: 'json' }
import allDocs from './Doc/_index.json' assert { type: 'json' }
import allAuthors from './Author/_index.json' assert { type: 'json' }

export { allChangelogs, allDocs, allAuthors }

export const allDocuments = [...allChangelogs, ...allDocs, ...allAuthors]


